export var convertToCreateReportInfoCommand = function (data) {
    return {
        buildingName: data.name,
        requirementIds: data.requirement ? [data.requirement] : null,
        category: data.isFloorPlan,
    };
};
